const DotnetMixin = {
  methods: {
    processOnRenderErrors(errors) {
      const mappedErrors = {};
      errors.forEach((error) => {
        if (error.value.errors[0] && error.value.errors[0].errorMessage) {
          if (errors.key) {
            mappedErrors[error.key.toLowerCase()] = Array.isArray(error.value.errors[0].errorMessage) ? error.value.errors[0].errorMessage : [error.value.errors[0].errorMessage];
          } else {
            mappedErrors.generic = Array.isArray(error.value.errors[0].errorMessage) ? error.value.errors[0].errorMessage : [error.value.errors[0].errorMessage];
          }
        }
      });
      this.$refs.formObserver.setErrors(mappedErrors);
    },
  },
};

export default DotnetMixin;
